let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("32AUX")).then(() => parcelRequire('039Sx'));